import { createSlice } from '@reduxjs/toolkit';
import { FeatureFlagServiceView } from './types';

const initialState: FeatureFlagServiceView = {
    isFeatureFlagScopeLoading: false,
};

const featureFlagServiceSlice = createSlice({
    name: 'featureFlagService',
    initialState,
    reducers: {
        setFeatureFlagServiceScopeLoading: (state) => ({ ...state, isFeatureFlagScopeLoading: true }),
        setFeatureFlagServiceScopeLoadingFinished: (state) => ({ ...state, isFeatureFlagScopeLoading: false }),
    },
});

export const { setFeatureFlagServiceScopeLoading, setFeatureFlagServiceScopeLoadingFinished } =
    featureFlagServiceSlice.actions;

export const featureFlagService = featureFlagServiceSlice.reducer;
